module.exports = __webpack_public_path__ + "img/new_mein_logo.c6a80f45.svg";